import type { ElementRef } from '@angular/core';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ComponentRegistryService {
  private store: Map<string, ElementRef> = new Map();

  public get(key: string): ElementRef | null {
    return this.store.get(key) || null;
  }

  public set(key: string, ref: ElementRef): void {
    this.store.set(key, ref);
  }

  public delete(key: string): void {
    this.store.delete(key);
  }
}
